<template>
    <div class="Map">


        <div class="map-set">
            <div id="map-container"> </div>

        </div>
    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, shallowRef, defineProps, watch, defineExpose, onUnmounted } from 'vue'
import AMapLoader from '@amap/amap-jsapi-loader'

const props = defineProps({
    mapData: {
        type: Array,
        default: () => {
            return []
        }
    },
    dataSourceId: {
        type: String,
        default: () => {
            return ''
        }
    },
    carMakerData: {
        type: Array,
        default: () => {
            return []
        }
    },
    dataSourceFrameNum: {
        type: String,
        default: () => {
            return ''
        }
    },
    wsCarFrameNum: {
        type: Array,
        default: () => {
            return []
        }
    },
})

const map = shallowRef(null)
let mapData = ref([])
let markers = ref([])
let centerPath = ref([])
let polylines = ref([])
const animationMarkerList = ref([]);
const colorLine = ref(0)
watch(
    () => props.mapData,
    (val) => {
        console.log(val, '2q3123123123123');
        // if (val.length != 0) {
        mapData.value = val
        // }
        if (map.value) {
            clearMap();
            set_map();
        } else {
            setTimeout(() => {
                clearMap();
                set_map();
            }, 1200);
        }
    }
)

watch(
    () => props.dataSourceId,
    (val) => {
        console.log(val);
        if (val) {
            addPolylines(val)
            selectedMarker(val)
        }
    }
)

// 更改小车颜色
watch(
    () => props.dataSourceFrameNum,
    (val) => {
        console.log(val);
        if (val) {
            // 所有小车还原成未选中模样
            resetChangeCarColor(val)
            // 改变小车颜色
            changeCarColor(val)
            // 移动地图中心点到选中车辆
            focusCarPosition(val)
        }
    },
    { deep: true }
)


watch(
    () => props.carMakerData,
    (val) => {
        console.log(val,'MakerData');
        if (val) {
            creatCar(val)
            // addPolylines(val)
            // selectedMarker(val)
        }
    },
    { deep: true }
)
watch(
    () => props.wsCarFrameNum,
    (val) => {
        let uniqueArr = [...new Set(val)];
        // console.log(val);
        if (val) {
            removeWsCar(uniqueArr)
        }
    },
    { deep: true }
)


const set_map = () => {
    if (map.value) {
        // map.value && addMarkers()
        map.value && addPolylines()
        // addMarkersInfoWindow()
    } else {
        setTimeout(() => {
            // map.value && addMarkers()
            map.value && addPolylines()
            // addMarkersInfoWindow()
        }, 1200);
    }
}

const drawMap = async () => {
    const AMap = await AMapLoader.load({
        key: '6588d9e5b6ae0751c799cb4c7b3e30be',
        version: '2.0',
        Loca: {
            // 是否加载 Loca， 缺省不加载
            version: '2.0.0' // Loca 版本，缺省 1.3.2
        },
        plugins: ['AMap.MouseTool', 'AMap.PolylineEditor', 'AMap.PolyEditor']
    })
    map.value = new AMap.Map('map-container', {
        zoom: 12,
        mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979',
        center: [103.981182679736, 36.0619054499201]
    })
    map.value.setZooms([2, 30])
    // map.value.setLayers([])
}

const addMarkers = () => {
    console.log(mapData.value);
    animationMarkerList.value && map.value.remove(animationMarkerList.value) // 清除所有的marker标记
    animationMarkerList.value = [] // 清空
    // 添加marker标记
    mapData.value.forEach(item => {
        addCarMarkers(item)
    })
    // map.value.add(markers.value) // 动态添加数据

    map.value.setFitView();//让所有点都在可是区域内
    setTimeout(() => {
        pauseTrackPlayBack()
    }, 500)
}

// 动态小车 轨迹 marker
const addCarMarkers = (data, index, angle) => {
    // resetMaker()
    let record = JSON.parse(JSON.stringify(data))
    console.log(record, 'record');
    var marker;
    AMap.plugin('AMap.MoveAnimation', function () {
        record.lineArr.map(item => {
            console.log(item[0], 'item[0]');
            marker = new AMap.Marker({
                map: map.value,
                position: item[1],
                icon: require('@/assets/images/car.png'),
                offset: new AMap.Pixel(-25, -30),

            });
            // marker.dom.style.transform = `translate(-3px, -14px) scale(1) rotate(${angle-90}deg)`
            console.log(43242343, marker);
            // that.animationMaker.push(marker);
            marker.moveAlong(item, {
                // 每一段的时长
                duration: 1500,//可根据实际采集时间间隔设置
                // JSAPI2.0 是否延道路自动设置角度在 moveAlong 里设置
                autoRotation: true,
                circlable: false// 是否循环播放
            });
            // marker.on('moving', function (e) {
            //     // console.log(e.target.getLabel(), 'eeeee');
            // })

            // 计算路线中心点
            let pos = [0, 0];
            item.map(ele => {

                pos[0] += ele[0];
                pos[1] += ele[1];
            });
            pos[0] = pos[0] / item.length;
            pos[1] = pos[1] / item.length;
            console.log(pos, 'pos');
            console.log(centerPath.value, 'centerPath.value');
            centerPath.value.push(pos);
            let center = [0, 0];
            centerPath.value.map(item => {

                center[0] += item[0];
                center[1] += item[1];
            });
            console.log(center);
            map.value.setCenter([center[0] / centerPath.value.length, center[1] / centerPath.value.length], true);

        })
        marker.id = record.id
        return marker
    });
    console.log(marker, 'this.animationMaker');
    animationMarkerList.value.push(marker)
    console.log(animationMarkerList.value, 'animationMarkerList.value');


    return marker
}

const cars = ref([]);//存储小车车架号
const carsEle = shallowRef(new Map())//存储小车对象
const creatCar = (carInfos) => {

    carInfos.map(info => {
        // console.log(cars.value);
        if (cars.value.includes(info.frameNum)) {
            //存在小车   移动位置
            console.log(cars.value,'222');
            
            let car = carsEle.value.get(info.frameNum);
            run(car, info)
            // console.log(car, '移动')
        } else {
            //不存在小车   创建小车
            carInit(info);
            cars.value.push(info.frameNum);
        }
    })
}

const carInit = (carInfo) => {
    // console.log(carInfo,"creating")
    let marker = new AMap.Marker({
        map: map.value,
        position: [carInfo.longitude, carInfo.latitude],
        icon: require('@/assets/images/car.png'),
        offset: new AMap.Pixel(-25, -30),
    });
    marker.frameNum = carInfo.frameNum;

    console.log(marker, 999);


    carsEle.value.set(carInfo.frameNum, marker);
}


const run = (car, carInfo) => {
    // console.log(car);
    AMap.plugin('AMap.MoveAnimation', function () {
        car.moveTo([carInfo.longitude, carInfo.latitude], {
            duration: 1000,
            // autoRotation:true,
        });
    })
}

// Map.vue 中添加暴露的方法
const resetCars = () => {
    // 清理所有小车
    cars.value.forEach(frameNum => {
        const car = carsEle.value.get(frameNum);
        if (car) {
            map.value.remove(car);
        }
    });
    cars.value = [];
    carsEle.value.clear();
};

/*暂停单个轨迹回放*/
const pauseTrackPlayBack = () => {
    animationMarkerList.value.map(item => {
        item.pauseMove();
    });
}
/*开始单个轨迹回放*/
const startTrackPlayBack = (id) => {
    console.log(animationMarkerList.value, '开始');
    let startData = mapData.value.find((ele) => {
        return ele.id == id
    });
    animationMarkerList.value.map(item => {
        if (item.id === id) {
            //使用setFitView方法
            item.resumeMove();
            console.log(startData);
            // addCarMarkers(startData)
            map.value.setFitView(item);//自适应显示
            map.value.setZoom(20);
        } else {
            item.pauseMove();
        }
    });
    console.log(markers.value);

}

// 定位
const selectedMarker = (id) => {
    console.log(id);
    polylines.value.map(item => {

        if (item.taskIds.includes(id)) {
            console.log(item, '123123123');
            map.value.setFitView(item);//自适应显示
            map.value.setZoom(17);
        }
    })

}
const carFrameNum = ref('')
// 更改小车颜色
const changeCarColor = (val) => {
    if (val) {
        carFrameNum.value = val
        //模拟消息推送-跟随小车
        if (cars.value.includes(val)) {
            // console.log(id)
            let car = carsEle.value.get(val);
            console.log(car);
            // 首先，创建一个新的Icon实例
            var newIcon = new AMap.Icon({
                image: require('@/assets/images/car_select.png'), // 新图标的URL
                size: new AMap.Size(50, 50), // 图标大小
                anchor: new AMap.Pixel(25, 30) // 图标的锚点
            });
            if (car) {
                car.setIcon(newIcon);
            }
        }
    } else {
        carFrameNum.value = undefined
    }
}
// 所有小车还原成未选中模样
const resetChangeCarColor = (val) => {
    var newIcon = new AMap.Icon({
        image: require('@/assets/images/car.png'), // 新图标的URL
        size: new AMap.Size(50, 50), // 图标大小
        anchor: new AMap.Pixel(25, 30) // 图标的锚点
    });
    cars.value.map(item => {
        console.log(item);
        carsEle.value.get(item).setIcon(newIcon);
    })
}
//聚焦到车辆到位置
const focusCarPosition = (val) => {
    if (cars.value.includes(val)) {
        let car = carsEle.value.get(val);
        console.log("选中车辆", car);
        if (car) {
            // 获取车辆当前位置
            const position = car.getPosition();
            console.log("选中车辆实时位置", position);
            if (position) {
              // 移动地图中心点到车辆位置
              map.value.setCenter(position, true);
              // 设置合适的缩放级别
              map.value.setZoom(17);
            }
        }
    }
}

// 初始化 刚进页面展示的框和线的集合  数据
const CoveringTool = shallowRef(null);

// 画线
const addPolylines = (id) => {
    polylines.value && map.value.remove(polylines.value) // 清除所有的线
    polylines.value = []
    // 添加线
    mapData.value.forEach(item => {
        if (item.id === id) {
            colorLine.value = '#0093FE'
        } else {
            colorLine.value = 'blue'  // #908A9B
        }
        polylines.value.push(addDrawLines(item, colorLine.value))
    })
    map.value.add(polylines.value) // 动态添加数据
    map.value.setFitView();//让所有点都在可是区域内
}

const addDrawLines = (item, color) => {
    let record = JSON.parse(JSON.stringify(item))
    record.locationInfo = JSON.parse(record.locationInfo)
    // record.locationInfo = record.locationInfo.map(i => {
    //     return i.map(Number)
    // })
    if (record.locationInfo.type === 'polygon') {
        // 画面
        CoveringTool.value = new AMap.Polygon({
            path: record.locationInfo.coordinates,
            zIndex: 50,
            bubble: true,
            strokeColor: "#F23218",
            strokeOpacity: 1,
            strokeWeight: 2,
            strokeOpacity: 0.7,
            fillColor: '#F2AA1E',
            fillOpacity: 0.4,
            // 线样式还支持 'dashed'
            strokeStyle: "solid",
        })
    } else {

        // 画线
        // CoveringTool.value = new AMap.Polyline({
        //     path: record.locationInfo.coordinates,
        //     cursor: 'pointer',
        //     borderWeight: 3,
        //     strokeColor: color,
        //     strokeOpacity: 1,
        //     strokeWeight: 6,
        //     // 折线样式还支持 'dashed'
        //     strokeStyle: "solid",
        //     zIndex: 50,
        // })

        // 画圆
        CoveringTool.value = new AMap.Circle({
            center: record.locationInfo.coordinates,
            radius: record.locationInfo.radius, //半径
            borderWeight: 3,
            strokeColor: "#F23218",
            strokeOpacity: 1,
            strokeWeight: 2,
            strokeOpacity: 0.7,
            fillOpacity: 0.4,
            strokeStyle: 'solid',
            strokeDasharray: [10, 10],
            // 线样式还支持 'dashed'
            fillColor: '#F2AA1E',
            zIndex: 50,
        })
    }
    CoveringTool.value.taskIds = record.taskIds
    return CoveringTool.value


}

// 不推数据 清除小车
const removeWsCar = (info) => {
    // let copyCar = JSON.parse(JSON.stringify(cars.value))
    // console.log(copyCar);
    // console.log(info);
    info.map(item => {
        if (cars.value.includes(item)) {
            console.log(item);
            console.log(123);
            let car = carsEle.value.get(item);
            if (car) {
                map.value.remove(car)  // 清除指定的marker标记
                carsEle.value.delete(item);  // carsEle.value 对象里面的数据
                cars.value = cars.value.filter(element => element !== item); // 存储小车的车架号
            }
        } else {
            // console.log(item);
        }
    })
    console.log(cars.value);
    console.log(carsEle.value);
}

const resetMaker = () => {
    animationMarkerList.value.map(item => {
        item.stopMove();
        item.setMap(null);
    });
    // animationMarkerList.value = [];
}
//清除地图;
const clearMap = () => {
    if (window.loca) {
        //清空所有图层，包括图层的光源
        window.loca.clear();
    }
    map.value && map.value.clearMap();

}
//销毁地图
const destroyMap = () => {
    map.value && map.value.destroy();
    console.info("地图已销毁");
}

onMounted(async () => {
    await drawMap()
    // await addMarkers()
})

onBeforeMount(() => {
    // convertLightList()
    destroyMap()

})
onUnmounted(() => {
    carsEle.value && map.value.remove(carsEle.value) // 清除所有的marker标记
    carsEle.value = null // 清空
});


defineExpose({ startTrackPlayBack, pauseTrackPlayBack, resetChangeCarColor, carsEle, map, resetCars })

</script>
<style lang="less" scoped>
#map-container {
    width: 100%;
    height: 92.3vh;
}

/deep/ .amap-logo {
    display: none !important;
}

/deep/ .amap-copyright {
    opacity: 0 !important;
}
</style>
